import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation } from '@tanstack/react-query';
import { Risk } from '@/components/views/Resolution886/enums';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';

interface CreateResolution886CategoryResultParams {
	assessment_id: string;
	organization_id: string;
	company_id: string;
	category_key: string | null;
	category_result_risk: Risk | null;
	category_result_observation?: string;
}

const Service = Resolution886ReportService.getInstance();

export function useCreateResolution886CategoryResult() {
	return useMutation({
		mutationFn: async (params: CreateResolution886CategoryResultParams) => Service.createCategoryResult(params),
		onError: () => {
			message.error(I18n.get('Error creating category result'));
		}
	});
}
